import React from "react";

const SidebarDivider = () => <div className="sidebarDivider" />;

export default SidebarDivider;
